import { connect } from 'react-redux';
import { get } from 'lodash/fp';

import { fetchStaticContent } from '../actions/contentActions';

function connectStatic({ index, title, ...props }) {
  const mapStateToProps = ({ settings, staticContent }) => ({
    ...props,
    content: get('content')(staticContent[index]),
    errorMessages: get('errors.messages')(staticContent[index]),
    isLoading: get('isLoading')(staticContent[index]),
    htmlTitle: get(`content.${index}.htmlTitle`)(settings),
    description: get(`content.${index}.description`)(settings),
    title
  });

  const mapDispatchToProps = dispatch => ({
    onMount() {
      dispatch(fetchStaticContent(index));
    }
  });

  return connect(mapStateToProps, mapDispatchToProps);
}

export default connectStatic;
